import { useContext } from 'react'
import { TimeRegisterContext } from '../contexts/TimeRegister.context'

const useTimeRegisterContext = () => {
  const data = useContext(TimeRegisterContext)
  return data
}

export default useTimeRegisterContext
